/**
 * Development-only logger. Use instead of raw console.* in application code.
 */

type LogArgs = unknown[];

function isDev(): boolean {
  return import.meta.env.DEV;
}

export const devLog = (...args: LogArgs): void => {
  if (isDev()) {
    console.log(...args);
  }
};

export const devWarn = (...args: LogArgs): void => {
  if (isDev()) {
    console.warn(...args);
  }
};

export const devError = (...args: LogArgs): void => {
  if (isDev()) {
    console.error(...args);
  }
};

/** Silence console noise in production builds. */
export function setupProductionConsole(): void {
  if (isDev()) return;
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}
